import en from "./en.json";
import { languages as coreResources } from "@sf-core";
import { languages as adminResources } from "../areas/admin";
import { languages as analyticsResources } from "../areas/analytics";
import { languages as reportingResources } from "../areas/reporting";
import { languages as fileUploadResources } from "@sf-fileUpload";
import _ from "lodash";

export const translations = {
  ..._.merge({ en }, coreResources, adminResources,analyticsResources,reportingResources,fileUploadResources),
};
